import { isPrivateKey, isTerminateValue, noop } from '../helper'
import { getPrototypeOf, isArray, keys, objectPrototype } from '../shortcut'

import type { TRecord } from '../types'

export function recursiveTraverse(
  target: any,
  visitor: (value: any) => false | void = noop
): any {
  if (isTerminateValue(target)) {
    return
  }
  if (visitor(target) === false) return
  if (isArray(target)) {
    target.forEach((value) => {
      recursiveTraverse(value, visitor)
    })
  } else if (getPrototypeOf(target) === objectPrototype) {
    for (const key of keys(target)) {
      if (isPrivateKey(key)) continue
      recursiveTraverse(target[key], visitor)
    }
  }
}

export function traverse(
  target: any,
  visitor: (value: any) => false | void = noop
): void {
  if (isTerminateValue(target)) {
    return
  } else if (!isArray(target) && getPrototypeOf(target) !== objectPrototype) {
    if (visitor(target) === false) return
  } else if (isArray(target)) {
    target.forEach((value) => {
      traverse(value, visitor)
    })
  } else {
    for (const key of keys(target)) {
      if (isPrivateKey(key)) continue
      traverse(target[key], visitor)
    }
  }
}

export function traverseIn(
  target: any,
  path: PropertyKey[] = [],
  visitor: (value: any, path: PropertyKey[]) => false | void = noop
): any {
  if (isTerminateValue(target)) {
    return
  } else if (!isArray(target) && getPrototypeOf(target) !== objectPrototype) {
    if (visitor(target, path) === false) return
  } else if (isArray(target)) {
    target.forEach((value, index) => {
      traverseIn(value, path.concat(index), visitor)
    })
  } else {
    for (const key of keys(target)) {
      if (isPrivateKey(key)) continue
      traverseIn(target[key], path.concat(key), visitor)
    }
  }
}

export function traverseTo(
  target: any,
  visitor: (value: any) => any = noop
): any {
  if (isTerminateValue(target)) {
    return target
  }
  if (!isArray(target) && getPrototypeOf(target) !== objectPrototype) {
    return visitor(target)
  }
  if (isArray(target)) {
    return target.map((value) => traverseTo(value, visitor))
  } else {
    const obj: TRecord = {}
    for (const key of keys(target)) {
      if (isPrivateKey(key)) continue
      obj[key] = traverseTo(target[key], visitor)
    }
    return obj
  }
}
